import { css, jsx } from '@emotion/core';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Heading from '@/src/shared/components/Heading';
import { bp, colors } from '@/styles';

const style = {
  linksListContainer: css`
    margin-bottom: 12px;
    &:nth-last-of-type() {
      margin-bottom: 0;
    }
    @media ${bp.md} {
      width: calc(50% - 10px);
    }
    @media print {
      width: auto;
      margin-bottom: 12px;
      &:not(:first-child) {
        margin-left: 32px;
      }
    }
  `,
  linksList: css`
    list-style-type: none;
    margin-top: 2px;
    margin-bottom: 0;
  `,
  linkItem: css`
    color: ${colors.primaryBlue};
    font-size: 1.6rem;
    font-weight: 900;
    line-height: 2.4rem;
    margin-bottom: 0;
  `,
  item: css`
    font-size: 1.6rem;
    font-weight: 900;
    line-height: 2.4rem;
    margin-bottom: 0;
  `,
};

const HeroList = memo(function HeroList(props) {
  const { heading, list, codeName, descName, hrefInfo, link } = props;
  return (
    <div css={style.linksListContainer}>
      <Heading type={5} weight="bolder" theme="gray">
        {heading}
      </Heading>
      <ul css={style.linksList}>
        {list.map(item => {
          if (!item[codeName] || !item[descName]) {
            return null;
          }
          return (
            <>
              {link && (
                <li css={style.linkItem} key={item[codeName]}>
                  <Link href={`/${item[hrefInfo]}`} as={`/${item[hrefInfo]}`}>
                    <a>{item[descName]}</a>
                  </Link>
                </li>
              )}
              {!link && (
                <li css={style.item} key={item[codeName]}>
                  {item[descName]}
                </li>
              )}
            </>
          );
        })}
      </ul>
    </div>
  );
});

HeroList.propTypes = {
  heading: PropTypes.string,
  list: PropTypes.array,
  codeName: PropTypes.string,
  descName: PropTypes.string,
};

HeroList.defaultProps = {
  heading: '',
  list: [],
  codeName: 'c',
  descName: 'd',
};

export default HeroList;
